function initialOrder() {
	return {
		order_by: 'start_datetime',
		order_dir: 'desc',
	};
}

function initialFilters() {
	return {
		interview_type: null,
		status: null,
		job_uuid: null,
		from_date: null,
		to_date: null,
	};
}

export const state = () => ({
	all_interviews: null,
	candidate_interviews: null,
	search: null,
	filters: initialFilters(),
	order: initialOrder(),
	page: null,
});

export const mutations = {
	setAllInterviews(state: any, payload: any) {
		state.all_interviews = payload;
	},

	setCandidateInterviews(state: any, payload: any) {
		state.candidate_interviews = payload;
	},

	setFilters(state: any, payload: object) {
		state.filters = payload;
	},

	setOrder(state: any, payload: object) {
		state.order = payload;
	},

	setPage(state: any, payload: number | null) {
		state.page = payload;
	},

	setSearch(state: any, payload: string | null) {
		state.search = payload;
	},
};

export const getters = {
	getAllInterviews: (state: any) => state.all_interviews,

	getCandidateInterviews: (state: any) => state.candidate_interviews,

	getFilters: (state: any) => state.filters,

	getOrder: (state: any) => state.order,

	getSearch: (state: any) => state.search,

	hasFilters: (state: any) => {
		let data = JSON.parse(JSON.stringify(state.filters));

		Object.keys(data).forEach((key) => !data[key] && delete data[key]);

		return Object.keys(initialFilters()).some((key) => Object.keys(data).includes(key));
	},
};

export const actions = {
	getAllCompanyInterviews(state: any, payload: any) {
		const company_uuid = this.$auth.user.company.uuid;

		let data = {
			page: state.state.page,
			search: state.state.search,
			...state.state.order,
			...state.state.filters,
		};

		// overwrite the data if a payload exists
		if (payload) {
			data = { ...data, ...payload };
		}

		// Delete empty keys from the data to be posted
		Object.keys(data).forEach((key) => !data[key] && delete data[key]);

		return new Promise((resolve, reject) => {
			this.$axios
				.get(`/api/company/${company_uuid}/interviews`, {
					params: data,
				})
				.then((res) => {
					state.commit('setAllInterviews', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	getCandidateInterviewForCompany(state: any, payload: any) {
		const company_uuid = this.$auth.user.company.uuid;

		return new Promise((resolve, reject) => {
			this.$axios
				.get(`/api/company/${company_uuid}/interviews`, {
					params: payload,
				})
				.then((res) => {
					state.commit('setCandidateInterviews', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	schedule(state: any, payload: any) {
		const { job_uuid, ...data } = payload;

		if (job_uuid) {
			return new Promise((resolve, reject) => {
				this.$axios
					.post(`/api/jobs/${job_uuid}/interviews`, data)
					.then((res) => resolve(res.data))
					.catch((err) => reject(err));
			});
		}

		const company_uuid = this.$auth.user.company.uuid;

		return new Promise((resolve, reject) => {
			this.$axios
				.post(`/api/company/${company_uuid}/interviews`, data)
				.then((res) => resolve(res.data))
				.catch((err) => reject(err));
		});
	},

	updateNote(state: any, payload: any) {
		const { interview_uuid, ...data } = payload;

		return new Promise((resolve, reject) => {
			this.$axios
				.put(`api/interviews/${interview_uuid}/update-note`, data)
				.then((res) => {
					// Update the company and candidate interviews.
					state.dispatch('interviewUpdated', res.data);

					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	cancel({ dispatch, commit, getters, rootGetters }, interviewUuid: string) {
		return new Promise((resolve, reject) => {
			this.$axios
				.patch(`/api/interviews/${interviewUuid}/cancel`)
				.then((res) => {
					// Update the company and candidate interviews.
					dispatch('interviewUpdated', res.data);

					// Update the status of the interview in the job application's interviews.
					let applicationInterviews = JSON.parse(JSON.stringify(rootGetters['applications/getInterviews']));

					if (applicationInterviews) {
						applicationInterviews.data = applicationInterviews.data.map((interview) => {
							if (interview.uuid === interviewUuid) {
								interview.status = res.data.status;
							}
							return interview;
						});

						commit('applications/setInterviews', applicationInterviews, { root: true });
					}

					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	interviewUpdated(state: any, payload: any) {
		// Update the company's interviews.
		let companyInterviews = JSON.parse(JSON.stringify(state.state.all_interviews));

		if (companyInterviews?.data) {
			companyInterviews.data = companyInterviews.data.map((interview) =>
				interview.uuid === payload.uuid ? { ...interview, ...payload } : interview,
			);

			state.commit('setAllInterviews', companyInterviews);
		}

		// Update the candidate's interviews.
		let candidateInterviews = JSON.parse(JSON.stringify(state.state.candidate_interviews));

		if (candidateInterviews?.data) {
			candidateInterviews.data = candidateInterviews.data.map((interview) =>
				interview.uuid === payload.uuid ? { ...interview, ...payload } : interview,
			);

			state.commit('setCandidateInterviews', candidateInterviews);
		}
	},

	async generate(state: any, payload: any) {
		window.open(`${this.$axios.defaults.baseURL}/api/interviews/${payload}/generate-calender`, '_blank');
	},

	setFilters(state: any, payload: object) {
		state.commit('setFilters', payload);
	},

	setOrder(state: any, payload: string) {
		state.commit('setOrder', payload);
	},

	setPage(state: any, payload: number | null) {
		state.commit('setPage', payload);
	},

	setSearch(state: any, payload: string | null) {
		state.commit('setSearch', payload);
		state.commit('setPage', null);
	},

	resetFilters(state: any) {
		state.commit('setFilters', initialFilters());
		state.commit('setPage', null);
	},

	resetOrder(state: any) {
		state.commit('setOrder', initialOrder());
	},

	resetSearch(state: any) {
		state.commit('setSearch', null);
	},
};
